module.exports = __webpack_public_path__ + "resources/img/bg_cover_intro.e40f6100f1f7074e740efa2d8cb71ee3.png";